<div class="mainMenu headerSpacer">
  <span>&nbsp;</span>
</div>
<!--Logo-->
<div class="logo">
  <a [routerLink]="['/']">
    <img src="../../../assets/images/kawneer_logo.JPG" alt="Kawneer logo">
  </a>
</div>
<!--end Logo-->
<div class="login-bridge-block"></div>
<!--Account-->
<div class="account-container">
  <div class="account-menu-container">
    <!--Account List Items-->
    <ul class="account-list-items">
      <li class="fade-on-hover" #language (click)="onToggleLanguage()">
        <span class="k-icon k-i-globe-outline"></span><span class="k-icon k-i-arrow-60-down"></span>
        <!--Language Pop up-->
        <kendo-popup [anchor]="language" *ngIf="showLanguage" class="language-container" id="language-dropdown"
                     (click)="onToggleLanguage()">
          <div class="language-content">
            <ul>
              <li *ngFor="let language of languages" (click)="setLanguage(language.id)">
                <a>
                  <img [src]="language.image">&nbsp;{{language.value}}
                </a>
              </li>
            </ul>
          </div>
          <!--end language-content-->
        </kendo-popup>
        <!--END Language Pop Up-->
      </li>
      <li class="login fade-on-hover" #signIn (click)="onToggleSignIn()">
        <button class="sign-in-button" kendoButton primary="true">
          {{signInLanguageLabel}}
        </button>
      </li>
    </ul>
    <!--end Account List Items-->
  </div>
  <!--end menu-container-->
</div>
